import React, { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { TEST_IDS } from "@/lib/testIds";
import { LINKS } from "@/lib/links";

const CALENDLY_CSS = "https://assets.calendly.com/assets/external/widget.css";
const CALENDLY_JS = "https://assets.calendly.com/assets/external/widget.js";

function ensureCalendlyAssets() {
  if (typeof document === "undefined") return;
  if (!document.querySelector(`link[href="${CALENDLY_CSS}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = CALENDLY_CSS;
    document.head.appendChild(link);
  }
  if (!document.querySelector(`script[src="${CALENDLY_JS}"]`)) {
    const script = document.createElement("script");
    script.src = CALENDLY_JS;
    script.async = true;
    document.body.appendChild(script);
  }
}

export const BookCall = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    ensureCalendlyAssets();
  }, []);

  return (
    <section
      id="contact"
      data-testid={TEST_IDS.book.section}
      className="bg-paper py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-32">
            <p className="eyebrow mb-7">A Conversation</p>
            <h2
              className="font-serif text-nearblack leading-[1.06] text-balance"
              style={{ fontSize: "clamp(2rem, 3.6vw, 3.2rem)", fontWeight: 400 }}
            >
              Wondering if this approach is{" "}
              <em className="italic text-camel">right for you?</em>
            </h2>
            <p className="mt-7 text-nearblack/75 text-[15px] md:text-base leading-[1.85] font-light max-w-md">
              If you’re exploring how to create more control, liquidity, and
              long-term structure with your money, start with a conversation.
              No pressure — just a quiet, honest look at where you are and
              where you want to go.
            </p>

            <a
              href={LINKS.calendly}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={TEST_IDS.book.cta}
              className="mt-9 inline-flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase text-nearblack hover:text-camel transition-colors"
            >
              Open in Calendly
              <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </div>

          <div className="lg:col-span-8">
            <div
              ref={widgetRef}
              data-testid={TEST_IDS.book.calendly}
              className="calendly-inline-widget border border-paperdeep bg-paper"
              data-url={`${LINKS.calendly}?hide_gdpr_banner=1&primary_color=B89A6E&text_color=1C1A17&background_color=F5F0E8`}
              style={{ minWidth: "320px", height: "740px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
